export default "__VITE_ASSET__UbM018ID__"